import { useState } from 'react';
import { Search } from 'lucide-react';
import { AdminLog } from '../../types';

// Mock admin logs
const mockLogs: AdminLog[] = [
  {
    id: '1',
    operator: 'admin',
    action: 'user_credit_adjustment',
    target: 'john_doe',
    timestamp: '2024-03-15T10:30:00Z',
    details: 'Added 50 credits',
  },
  {
    id: '2',
    operator: 'admin',
    action: 'user_status_change',
    target: 'jane_smith',
    timestamp: '2024-03-14T15:45:00Z',
    details: 'Account disabled',
  },
  {
    id: '3',
    operator: 'system',
    action: 'invite_code_generation',
    target: 'DEMO2024',
    timestamp: '2024-03-13T09:20:00Z',
    details: 'Generated new invitation code',
  },
];

export function AdminLogs() {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredLogs = mockLogs.filter(
    (log) =>
      log.operator.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.action.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.target.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.details?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-[--text-primary]">Admin Logs</h1>
        <p className="mt-2 text-sm text-[--text-secondary]">
          Track and monitor administrative actions
        </p>
      </div>

      {/* Search Bar */}
      <div className="mb-6">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[--text-disabled]" />
          <input
            type="text"
            placeholder="Search logs..."
            className="pl-10 pr-4 py-2 w-full border border-[--border-secondary] rounded-lg focus:ring-primary-500 focus:border-primary-500 bg-[--bg-primary] text-[--text-primary]"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Logs Table */}
      <div className="bg-[--bg-primary] shadow overflow-hidden sm:rounded-lg">
        <table className="min-w-full divide-y divide-[--border-primary]">
          <thead className="bg-[--bg-secondary]">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-[--text-secondary] uppercase tracking-wider">
                Timestamp
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-[--text-secondary] uppercase tracking-wider">
                Operator
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-[--text-secondary] uppercase tracking-wider">
                Action
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-[--text-secondary] uppercase tracking-wider">
                Target
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-[--text-secondary] uppercase tracking-wider">
                Details
              </th>
            </tr>
          </thead>
          <tbody className="bg-[--bg-primary] divide-y divide-[--border-primary]">
            {filteredLogs.map((log) => (
              <tr key={log.id}>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-[--text-secondary]">
                  {new Date(log.timestamp).toLocaleString()}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span
                    className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      log.operator === 'system'
                        ? 'bg-[--primary-100] text-[--primary-800] dark:bg-[rgb(var(--primary-900)/0.2)] dark:text-[--primary-200]'
                        : 'bg-[--primary-100] text-[--primary-800] dark:bg-[rgb(var(--primary-900)/0.2)] dark:text-[--primary-200]'
                    }`}
                  >
                    {log.operator}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-[--text-primary]">
                  {log.action.replace(/_/g, ' ')}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-[--text-secondary]">
                  {log.target}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-[--text-secondary]">
                  {log.details}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}